// Bugfix 30 (#1403): oefeningenbibliotheek van de Template Maker. Zoeken op
// naam, per spiergroep bladeren en favorieten, alles in de browser. Dezelfde
// controller draait rechts in de builder (modus "toevoegen") en in het venster
// "Oefening vervangen" (modus "vervangen").
//
// Bugfix 29 (#1402) bouwt een vergelijkbare compacte zoeker voor oefening
// vervangen in het schema van de sporter; die twee kunnen later samen.
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["zoek", "tab", "groepen", "terug", "groepnaam", "resultaten", "oefening", "leeg"]
  static values = { modus: String }

  connect() {
    this.tab = "spiergroepen"
    this.groep = null
    this.opFavoriet = (event) => this.werkFavorietBij(event.detail.typeId, event.detail.favoriet)
    document.addEventListener("oefening-zoeker:favoriet", this.opFavoriet)
    this.filter()
  }

  disconnect() {
    document.removeEventListener("oefening-zoeker:favoriet", this.opFavoriet)
  }

  filter() {
    const zoek = this.hasZoekTarget ? this.zoekTarget.value.trim().toLowerCase() : ""
    const lijstTonen = zoek !== "" || this.groep !== null || this.tab === "favorieten"

    this.groepenTarget.hidden = lijstTonen
    this.resultatenTarget.hidden = !lijstTonen
    this.terugTarget.hidden = this.groep === null

    let zichtbaar = 0
    if (lijstTonen) {
      this.oefeningTargets.forEach((oefening) => {
        const past = (zoek === "" || oefening.dataset.naam.includes(zoek)) &&
          (this.groep === null || oefening.dataset.categorie === this.groep) &&
          (this.tab !== "favorieten" || oefening.dataset.favoriet === "true")
        oefening.hidden = !past
        if (past) zichtbaar += 1
      })
    }
    if (this.hasLeegTarget) {
      this.leegTarget.hidden = !lijstTonen || zichtbaar > 0
      this.leegTarget.textContent = this.tab === "favorieten" && zoek === ""
        ? this.leegTarget.dataset.tekstFavorieten
        : this.leegTarget.dataset.tekstZoeken
    }
  }

  openGroep(event) {
    this.groep = event.currentTarget.dataset.categorie
    if (this.hasGroepnaamTarget) {
      const label = event.currentTarget.querySelector("span:nth-of-type(2)")
      this.groepnaamTarget.textContent = label ? label.textContent : this.groep
    }
    this.filter()
  }

  terug() {
    this.groep = null
    this.filter()
    if (this.hasZoekTarget) this.zoekTarget.focus()
  }

  kiesTab(event) {
    this.tab = event.currentTarget.dataset.tab
    this.groep = null
    this.tabTargets.forEach((tab) => tab.setAttribute("aria-selected", tab === event.currentTarget ? "true" : "false"))
    this.filter()
  }

  // Enter voegt de eerste gevonden oefening toe; Escape maakt het zoekveld leeg.
  toets(event) {
    if (event.key === "Enter") {
      event.preventDefault()
      const eerste = this.oefeningTargets.find((oefening) => !oefening.hidden && !this.resultatenTarget.hidden)
      const form = eerste && eerste.querySelector("form")
      if (form) form.requestSubmit()
    } else if (event.key === "Escape" && this.zoekTarget.value !== "") {
      event.stopPropagation()
      this.zoekTarget.value = ""
      this.filter()
    }
  }

  // De bibliotheek voegt toe aan de sessie die nu in het midden staat.
  voorVerzenden(event) {
    const form = event.target
    if (this.modusValue === "toevoegen") {
      const midden = document.getElementById("tb-midden")
      const veld = form.querySelector('input[name="sessie_id"]')
      if (midden && veld && midden.dataset.sessieId) veld.value = midden.dataset.sessieId
    } else if (!form.getAttribute("action") || form.getAttribute("action") === "#") {
      event.preventDefault()
    }
  }

  async favoriet(event) {
    const knop = event.currentTarget
    const oefening = knop.closest("[data-type-id]")
    const meta = document.querySelector('meta[name="csrf-token"]')
    try {
      const antwoord = await fetch(knop.dataset.url, {
        method: "POST",
        headers: { Accept: "application/json", "X-CSRF-Token": meta ? meta.content : "" },
        credentials: "same-origin"
      })
      if (!antwoord.ok) return
      const data = await antwoord.json()
      document.dispatchEvent(new CustomEvent("oefening-zoeker:favoriet", {
        detail: { typeId: oefening.dataset.typeId, favoriet: data.favoriet }
      }))
    } catch (fout) {
      // geen verbinding: de ster blijft zoals hij was
    }
  }

  werkFavorietBij(typeId, favoriet) {
    this.oefeningTargets.forEach((oefening) => {
      if (oefening.dataset.typeId !== String(typeId)) return
      oefening.dataset.favoriet = favoriet ? "true" : "false"
      const ster = oefening.querySelector(".tb-ster")
      if (ster) ster.setAttribute("aria-pressed", favoriet ? "true" : "false")
    })
    this.filter()
  }
}
